import JobsDashboard from "./_components/JobsDashboard";

export default function HomeJobsPage() {
  return <JobsDashboard />;
}
